import React from "react"
import {  Link } from 'react-router-dom'
import FacebookLogin from 'react-facebook-login';
import config from 'react-global-configuration';
import AuthActions from '../actions/AuthActions';
import AuthStore   from '../stores/AuthStore'
import ErrorStore   from '../stores/ErrorStore'
import Account from '../vo/Account'
import LineLogin from "./parts/LineLogin" ;
import HeaderAll from './parts/HeaderAll'
//import Header from "./parts/Header"
//import Footer from "./parts/Footer"
import styles from "../styles/signup.css"


export default class SignUpApp extends React.Component {

  constructor(){
    super()
    this.authStoreErrorChangeHandler = this.authStoreErrorChangeHandler.bind(this)
    this.authStoreUpdateHandler = this.authStoreUpdateHandler.bind(this)
    this.responseFacebook = this.responseFacebook.bind(this)
    this.responseLine = this.responseLine.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.authStoreChangeHandler = this.authStoreChangeHandler.bind(this)
    this.errorStoreChangeHandler = this.errorStoreChangeHandler.bind(this)
    this.accountCreatedHandler = this.accountCreatedHandler.bind(this)
    this.progressToPayment = this.progressToPayment.bind(this)
    this.componentClicked = this.componentClicked.bind(this)
    this.is_facebook_login = false
    this.state = {

      account:null,
      account_type:"",
      account_id:"",
      error_code:null,
      message:null,
      created:false,
      picture:null
    }
  }
  componentDidMount(){
    AuthStore.addChangeListener(this.authStoreChangeHandler)
    AuthStore.addChangeListener(this.authStoreErrorChangeHandler,"auth_error")
    AuthStore.addChangeListener(this.authStoreUpdateHandler,"account_update")
    AuthStore.addChangeListener(this.accountCreatedHandler,"account_created")
    ErrorStore.addChangeListener(this.errorStoreChangeHandler)
  }

  componentWillUnmount(){
    AuthStore.removeChangeListener(this.authStoreChangeHandler)
    AuthStore.removeChangeListener(this.authStoreErrorChangeHandler,"auth_error")
    AuthStore.removeChangeListener(this.authStoreUpdateHandler,"account_update")
    AuthStore.removeChangeListener(this.accountCreatedHandler,"account_created")
    ErrorStore.removeChangeListener(this.errorStoreChangeHandler)
  }

  responseFacebook(response){

      if(this.is_facebook_login){
        this.setState({
          account_type:"facebook",
          account_id:response.id,
          picture:response.picture.data.url
        })

        const item = new Account({
          name:response.name,
          mail:response.email
        })
        AuthActions.createNew(item)
      }


  }

  responseLine(user_id,user_name,picture){
    this.setState({
      account_type:"line",
      account_id:user_id,
      picture:picture
    })
    const item = new Account({
      name:user_name,
      mail:""
    })
    AuthActions.createNew(item)
  }

  componentClicked(){
    this.is_facebook_login = true
  }
  authStoreChangeHandler(){
    if(AuthStore.isAuth()){
        window.location = "/club/payment"
    }
    //console.log( AuthStore.getToken())
    //this.props.history.push("/payment")

  }

  authStoreErrorChangeHandler(){

    this.setState({
      account: AuthStore.getUserInfo()
    })
  }

  authStoreUpdateHandler(){
    this.setState({
      account: AuthStore.getUserInfo()
    })
  }
  handleChange(e){
    const target = e.target
    AuthActions.update(target.name, target.value)
  }

  accountCreatedHandler(){
    this.setState({
      created:true
    })
    //window.location = "/payment"
  }

  progressToPayment(){
    AuthActions.auth(this.state.account_id, this.state.account_type, null, this.state.picture)
  }

  handleSubmit(){
      AuthActions.create(this.state.account_id, this.state.account_type, this.state.account)
  }

  errorStoreChangeHandler(){
    this.setState({
      code:ErrorStore.getCode()
    })
  }




  render(){

    var inputHtml = null
    var logintHtml = null
    var progreeHtml = null
    var message = null
    var backhtml = <section><Link to="/login">ログイン（すでに登録済みの方）</Link></section>
    if(this.state.created){
      progreeHtml = <section className="input-box"><div className="btn-box">
      <button onClick={this.progressToPayment} className="create-btn">月会費の支払いへ進む</button>
          </div>
          </section>
      backhtml = null
      message = <section>The House Clubの月会費は3,000円です。クレジットカードでの自動課金となります。</section>
    }else if(this.state.account){
      inputHtml = <section className="input-box">
      <div className="form-box-item">
        <label className="label-def" htmlFor="name">お名前</label>
        <input className="default-input" type="text" name="name" value={this.state.account.name} onChange={this.handleChange} placeholder="お名前" />
      </div>
      <div className="form-box-item">
        <label className="label-def" htmlFor="mail">メールアドレス</label>
        <input className="default-input" type="text" name="mail" value={this.state.account.mail} onChange={this.handleChange} placeholder="メールアドレス" />
      </div>
      <div className="form-box-item">
      <label htmlFor="rep">クラブ会員規約</label>

      <iframe
      className="border_w"
      width="100%"
      height="280"
      src="/club/html/regulation.html"
      >
      </iframe>

      </div>
      <div className="btn-box">
      <button onClick={this.handleSubmit} className="create-btn">規約に同意しアカウントを作成</button>
          </div>
          </section>
    }else{
      logintHtml =       <section>
              <FacebookLogin
                appId="1809837605968406"
                autoLoad={false}
                fields="name,email,picture"
                onClick={this.componentClicked}
                callback={this.responseFacebook}
                cssClass="fb-button-class"
                textButton="Facebookで新規登録"
                icon="fab fa-facebook"
                redirectUri={config.get("CALL_BACK_NEW")}
              />
              <LineLogin
                responseLine={this.responseLine}
                client_id={1604258661}
                scope={"profile"}
                redirect_uri={config.get("CALL_BACK_NEW")}
                client_secret={"a66a271fdd7dd440a6279d3764916f8b"}
                textButton="LINEで新規登録"
                path="signup"
              />


            </section>
    }


    if(this.state.code){
      if(this.state.code = 412){
          message = <div className="message">すでにこのアカウントでユーザー登録されています。</div>
      }else{
          message = <div className="message">エラーが発生しました。エラーコード:{this.state.code} </div>
      }

    }

    return(
      <div>

        <HeaderAll />
        <main>
        <div className="main-pannel">
        {message}
        {logintHtml}
        {inputHtml}
        {progreeHtml}
        {backhtml}
        </div>

        </main>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SignUpApp.js